// app/src/atoms/snapping.atom.ts
import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { EditHistory, type EditCommand } from '@/lib/editHistory';
import { DEFAULT_SNAP_SETTINGS, type SnapResult, type SnapSettings } from '@/lib/snapping/types';

export const snapSettingsAtom = atomWithStorage<SnapSettings>(
  'gis.snapSettings',
  DEFAULT_SNAP_SETTINGS,
);

/** Live snap for the current frame; drives the SnapIndicator. */
export const activeSnapAtom = atom<SnapResult | null>(null);

// --- Edit history -----------------------------------------------------------
const historyRef = new EditHistory();
const editHistoryAtom = atom(historyRef);
/** Bumped on every history mutation so canUndo/canRedo consumers re-render. */
export const editHistoryVersionAtom = atom(0);

export const pushCommandAtom = atom(null, (get, set, cmd: EditCommand) => {
  get(editHistoryAtom).push(cmd);
  set(editHistoryVersionAtom, (v) => v + 1);
});

export const undoAtom = atom(null, (get, set) => {
  get(editHistoryAtom).undo();
  set(editHistoryVersionAtom, (v) => v + 1);
});

export const redoAtom = atom(null, (get, set) => {
  get(editHistoryAtom).redo();
  set(editHistoryVersionAtom, (v) => v + 1);
});

export const clearHistoryAtom = atom(null, (get, set) => {
  get(editHistoryAtom).clear();
  set(editHistoryVersionAtom, (v) => v + 1);
});

export const canUndoAtom = atom((get) => {
  get(editHistoryVersionAtom); // subscribe so this recomputes after mutations
  return get(editHistoryAtom).canUndo;
});
export const canRedoAtom = atom((get) => {
  get(editHistoryVersionAtom);
  return get(editHistoryAtom).canRedo;
});
